$(document).on('ready', function() {
    $("a,button,input[type='submit'],input[type='checkbox']").on('click', function() {
        
        if ($(this).hasClass('ui-slider-handle'))
            var CurrentButtonValue = $(this).parent().parent().find('.label').text();  
        else if ($(this).attr('type') == 'checkbox')
            var CurrentButtonValue = $(this).parent().find('label').text(); 
        else if($(this).val())
            var CurrentButtonValue = $(this).val();
        else 
            var CurrentButtonValue = $(this).text();
       	
        if (typeof(dataLayer) != 'undefined') {
            dataLayer.push({ 'CurrentButtonValue': CurrentButtonValue });
            dataLayer.push({ 'event': 'ButtonClick' });
        }

    })
});